import React, { useContext } from 'react'
import { connectToLocale, PDPModal } from '@insight/toolkit-react'
import {getDefaultLoggedOutSalesOrg, l} from '@insight/toolkit-utils'
import { getProductInformation } from '../api/getProductDetails'
import { PDPContext } from '../context'
import { getWebPricingFeatureFlag, hideLoggedOutPricingFF } from '../shared'

function ProductMiniPDP({ context }) {
  const { contractId, miniPDP, setMiniPDP, isLoggedIn } = useContext(PDPContext)
  const { contract, isIPSUser, userInformation } = context
  const isStockAndPriceDisabled = isLoggedIn ? Insight?.webGroupPermissions?.includes('disable_stock_and_price_display') : false
  const isViewPricingEnabled = isLoggedIn ? userInformation?.permissions?.enableViewPricing : true
  const hideLoggedOutPricing = hideLoggedOutPricingFF();
  const showPrice = !isStockAndPriceDisabled && isViewPricingEnabled && !hideLoggedOutPricing;
  const newWebPriceFeature = getWebPricingFeatureFlag();
  const salesOrg =  userInformation?.salesOrg || getDefaultLoggedOutSalesOrg(l(), isIPSUser)
  const isIPSUserWithContract = isIPSUser && !!contract
  const isSingleContract = !(contract?.contractName == 'All' && isIPSUser);
  const isMultipleContract = isLoggedIn && contract?.contractName === "All" && isIPSUserWithContract
  // display list price for all logout user and login user with list_price permission and ips user
  const displayListPrice =
    !isLoggedIn || Insight?.webGroupPermissions?.includes('list_price') || isIPSUser

  return (
    <PDPModal
      isIPSUser={isIPSUser}
      hasContractSection={isIPSUserWithContract && (isSingleContract || isMultipleContract)}
      displayListPrice={displayListPrice}
      showPDP={miniPDP}
      showPrice={showPrice}
      showSaving={newWebPriceFeature}
      showStock={!isStockAndPriceDisabled}
      showBackOrder
      isLoggedIn={isLoggedIn}
      fetchProduct={() =>
        getProductInformation({
          locale: l(),
          materialId: miniPDP,
          contractId,
          salesOrg
        })
      }
      onClose={() => setMiniPDP(false)}
    />
  )
}

export default connectToLocale(ProductMiniPDP)
